import React, { useState, useCallback } from "react";
import { Link } from "react-router-dom";
import * as htmlToImage from "html-to-image";
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from "html-to-image";
import SwatchDND from "./SwatchDND";
import "./Palette.css";
import Swatches from "./Swatches";
import download from "downloadjs";

const Palette = ({ isMobile }) => {
  const [basket, setBasket] = useState([]);
  const [width, setWidth] = React.useState(window.innerWidth);

  React.useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleWindowResize);

    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  const addSwatch = (swatch) => {
    if (basket.some((e) => e.id === swatch.id)) {
      alert("Swatch is already in palette 🤭");
      setBasket([...basket]);
      return;
    }

    if (width < 480) {
      if (basket.length < 5) {
        setBasket([...basket, swatch]);
      } else {
        alert(
          `Sorry, only 5 swatches allowed in palette 😬. To include another color, first remove one of the swatches.`
        );
        setBasket([...basket]);
      }
    }

    if (width > 480) {
      if (basket.length < 8) {
        setBasket([...basket, swatch]);
      } else {
        alert(
          `Sorry, only 8 swatches allowed in palette 😬. To include another color, first remove one of the swatches.`
        );
        setBasket([...basket]);
      }
    }
  };

  const movePaletteItem = useCallback(
    (dragIndex, hoverIndex) => {
      const dragItem = basket[dragIndex];
      const hoverItem = basket[hoverIndex];
      // Swap places of dragItem and hoverItem in the pets array
      setBasket((basket) => {
        const updatedBasket = [...basket];
        updatedBasket[dragIndex] = hoverItem;
        updatedBasket[hoverIndex] = dragItem;
        return updatedBasket;
      });
    },
    [basket]
  );

  const removeSwatch = (id) => {
    const newBasket = basket.filter((basket) => basket.id !== id);
    setBasket(newBasket);
  };

  const takePhoto = () => {
    htmlToImage
      .toPng(document.getElementById("basketBox"))
      .then(function (dataUrl) {
        download(dataUrl, "basket.png");
      });
  };

  return (
    <div className="basketContainer">
      <Swatches addSwatch={addSwatch} />
      <div className={!basket.length ? "emptyBasket" : "basket"}>
        {!basket?.length ? (
          <div className="iconInstructions">
            <img className="girlIcon" src="./images/GirlIcon.png" alt="icon" />
            <p className="dropInstructions">Yarn color palette</p>
          </div>
        ) : null}
        <div className="basketBox" id="basketBox">
          {basket?.map((swatch, index) => (
            <SwatchDND
              draggable
              key={swatch.id}
              id={swatch.id}
              url={swatch.url}
              index={index}
              isMobile={isMobile}
              inPalette={true}
              movePaletteItem={movePaletteItem}
              removeSwatch={removeSwatch}
            />
          ))}
        </div>
      </div>
      {basket.length ? (
        <div className="basketButtonContainer">
          <button className="resetButton" onClick={() => setBasket([])}>
            REMOVE ALL
          </button>
          {!isMobile && (
            <button className="resetButton" onClick={takePhoto}>
              TAKE PHOTO
            </button>
          )}

          <button
            className="purchaseButton"
            onClick={() =>
              window.open("https://www.thelittlehookcrochet.com/yarn", "_blank")
            }
          >
            {/* <a
              href="https://www.thelittlehookcrochet.com/yarn"
              target="_blank"
              rel="noreferrer"
              className="buttonTag"
            >
              Purchase Yarn
            </a> */}
            PURCHASE YARN
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default Palette;
